import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { LoadingController, Platform } from "ionic-angular";
import { AppSettings } from './app-settings'
// import {Storage} from '@ionic/storage';

import { HttpParams, HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Http, RequestOptions } from '@angular/http';


@Injectable()
export class ServerService {
    adruncount: any = 0;
    adruncount2: any = 0;
    constructor(public loadingCtrl: LoadingController,
        // public storage: Storage,
        private plat: Platform,
        private http: Http) {
    }

    private generateAppToken(): string {
        const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let token = 'atr_';
        for (let i = 0; i < 32; i++) {
            token += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return token;
    }

    private appendAppToken(body: FormData): void {
        body.append('token', this.generateAppToken());
    }

    auth(url, phone) {
        // let loading = this.loadingCtrl.create({ content: 'Please wait...' });
        // loading.present();
        try {
            // var firstHeaders = new Headers();
            // firstHeaders.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

            // const headers = new HttpHeaders();
            // headers.set('Content-Type', 'application/json; charset=utf-8');

            let body = new FormData();
            body.append("phone", phone);
            this.appendAppToken(body);
            return this.http.post(AppSettings.SERVER_URL + '' + url, body).map(res => res.json()).do((data) => {
            }).toPromise();
        } catch (err) {
            console.log(err);
        } finally {
            // loading.dismiss();
        }
    }

    validatePhone(url, mercazAllId, personalID, server, phone, isAndroid) {
        // let loading = this.loadingCtrl.create({ content: 'Please wait...' });
        // loading.present();
        try {
            // var firstHeaders = new Headers();
            // firstHeaders.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

            // const headers = new HttpHeaders();
            // headers.set('Content-Type', 'application/json; charset=utf-8');

            let body = new FormData();
            body.append("mercazAllId", mercazAllId);
            body.append("personalID", personalID);
            body.append("phone", phone);
            body.append("pqpq", server);
            body.append("isAndroid", isAndroid);
            this.appendAppToken(body);

            return this.http.post(AppSettings.SERVER_URL + '' + url, body).map(res => res.json()).do((data) => {
            }).toPromise();
        } catch (err) {
            console.log(err);
        } finally {
            // loading.dismiss();
        }

    }

    verifyPhoneOtp(url, mercazAllId, personalID, server, phone, otpCode) {
        try {
            let body = new FormData();
            body.append("mercazAllId", mercazAllId);
            body.append("personalID", personalID);
            body.append("phone", phone);
            body.append("pqpq", server);
            body.append("otpCode", otpCode);
            this.appendAppToken(body);

            return this.http.post(AppSettings.SERVER_URL + '' + url, body).map(res => res.json()).do((data) => {
            }).toPromise();
        } catch (err) {
            console.log(err);
        }
    }

    sendPostParams(url, params) {
        // let loading = this.loadingCtrl.create({ content: 'Please wait...' });
        // loading.present();
        try {
            // var firstHeaders = new Headers();
            // firstHeaders.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

            // const headers = new HttpHeaders();
            // headers.set('Content-Type', 'application/json; charset=utf-8');

            let body = new FormData();
            body.append("params", JSON.stringify(params));
            this.appendAppToken(body);
            return this.http.post(AppSettings.SERVER_URL + '' + url, body).map(res => res.json()).do((data) => {
            }).toPromise();
        } catch (err) {
            console.log(err);
        } finally {
            // loading.dismiss();
        }

    }

    getRooActivity(url, params) {
        try {
            let body = new FormData();
            body.append("date", params['date']);
            body.append("center_id", params['mercazAllId']);
            return this.http.post(AppSettings.ROO_API + '' + url, body).map(res => res.json()).do((data) => {
            }).toPromise();
        } catch (err) {
            console.log(err);
        } finally {
        }
    }

    getUserRooActivity(url, params) {
        try {
            let body = new FormData();
            body.append("customer_id", params['customer_id']);
            body.append("center_id", params['center_id']);
            return this.http.post(AppSettings.ROO_API + '' + url, body).map(res => res.json()).do((data) => {
            }).toPromise();
        } catch (err) {
            console.log(err);
        } finally {
        }
    }

    registerRooActivity(url, params) {
        try {
            let body = new FormData();
            body.append("center_id", params['center_id']);
            body.append("start", params['start']);
            body.append("end", params['end']);
            body.append("customer_id", params['customer_id']);
            body.append("customer_name", params['customer_name']);
            body.append("room_id", params['room_id']);
            body.append("name_comment", params['name_comment']);
            return this.http.post(AppSettings.ROO_API + '' + url, body).map(res => res.json()).do((data) => {
            }).toPromise();
        } catch (err) {
            console.log(err);
        } finally {
            // loading.dismiss();
        }
    }

    unregisterRooActivity(url, params) {
        try {
            let body = new FormData();
            body.append("center_id", params['center_id']);
            body.append("customer_id", params['customer_id']);
            body.append("event_id", params['event_id']);
            return this.http.post(AppSettings.ROO_API + '' + url, body).map(res => res.json()).do((data) => {
            }).toPromise();
        } catch (err) {
            console.log(err);
        } finally {
            // loading.dismiss();
        }
    }


}




//this._categories.next(categories);
//resolve(this.categories);


// WEBPACK FOOTER //
// ./src/services/server-service.ts